import { render, staticRenderFns } from "./AsbestosSitePage.component.html?vue&type=template&id=346a6177&scoped=true&external"
import script from "./AsbestosSitePage.component.ts?vue&type=script&lang=ts&external"
export * from "./AsbestosSitePage.component.ts?vue&type=script&lang=ts&external"
import style0 from "./AsbestosSitePage.component.scss?vue&type=style&index=0&id=346a6177&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346a6177",
  null
  
)

export default component.exports